import React, { useState, useEffect, Fragment } from 'react';
// import SmartTable from '../../extras/SmartTable';
import {
  getCompanies,
  mergeCompanies,
  verifyCompany,
} from '../../services/apiService';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LoadingCircleIcon from '../../icons/LoadingCircle';
import CompaniesTable from './utils/table';
import { PageHeader } from '../../extras/PageLayout';

function ManageCompanies() {
  const [data, setData] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState({});
  const [mergeCompany, setMergeCompany] = useState({});
  const [dialogStage, setDialogStage] = useState(0);

  // const columnHeads = [
  //   {
  //     label: 'Company Name',
  //     dataId: 'name',
  //   },
  //   {
  //     label: 'Website',
  //     dataId: 'website',
  //   },
  //   {
  //     label: 'Tags',
  //     dataId: 'tags',
  //     type: 'array',
  //   },
  //   {
  //     label: 'Verified',
  //     dataId: 'verified',
  //     type: 'select',
  //     selectOptions: { false: 'Unverified', true: 'Verified' },
  //   },
  //   {
  //     label: 'Updated At',
  //     dataId: 'updatedAt',
  //     type: 'date',
  //   },
  //   {
  //     label: 'Updated By',
  //     dataId: 'updatedBy',
  //   },
  // ];

  const MergeFormFields = [
    {
      label: 'Company Name',
      key: 'name',
    },
    {
      label: 'Company Website',
      key: 'website',
    },
    {
      label: 'Glassdoor URL',
      key: 'glassdoorUrl',
    },
  ];

  useEffect(() => {
    async function fetchCompanies() {
      const companies = await getCompanies();
      setData(companies);
    }

    if (data.length === 0) fetchCompanies();
  }, [data]);

  const handleMergeDialog = (row) => {
    setSelectedCompany(row);
    setDialogOpen(true);
  };

  const handleVerify = async (row) => {
    const response = await verifyCompany(row.id);
    const newData = data;
    newData.splice(
      newData.findIndex((item) => item.id === response.id),
      1,
      response
    );
    setData(newData);
  };

  const handleDialog = () => {
    setDialogStage(0);
    setDialogOpen((prevState) => !prevState);
  };

  const handleMerge = async () => {
    await mergeCompanies({
      companyIds: [mergeCompany.id, selectedCompany.id],
      resolvedEntity: formValues,
    });
    setData([]);
    handleDialog();
  };

  return (
    <div>
      <PageHeader
        title="Manage Companies"
        subtitle="View and manage company profiles"
      />
      {data.length !== 0 ? (
        <CompaniesTable
          rowData={data}
          handleMergeDialog={handleMergeDialog}
          handleVerify={handleVerify}
        />
      ) : (
        <div className='m-auto w-full mt-20 text-center'>
          <LoadingCircleIcon iconStyle='w-10 h-10 mr-2' />
          <h1>Loading...</h1>
        </div>
      )}

      {/* --- Form Dialog--- */}
      <Dialog
        open={dialogOpen}
        onClose={handleDialog}
        aria-labelledby='form-dialog-title'
        maxWidth='lg'
      >
        <DialogTitle id='form-dialog-title'>
          Merge with other company
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {dialogStage === 0 &&
              'Please select another company to merge the selected company with.'}
            {dialogStage === 1 &&
              'Please select attributes to keep when the companies are merged.'}
          </DialogContentText>
          {dialogStage === 0 && (
            <Autocomplete
              id='combo-box-demo'
              onChange={(event, value) => setMergeCompany(value)}
              options={data.filter(
                (company) => company.name !== selectedCompany.name
              )}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField {...params} label='Combo box' variant='outlined' />
              )}
            />
          )}
          {dialogStage === 1 && (
            <MergeForm
              formValues={formValues}
              setFormValues={setFormValues}
              fields={MergeFormFields}
              mergeCompany={mergeCompany}
              selectedCompany={selectedCompany}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialog} color='primary'>
            Cancel
          </Button>
          {dialogStage === 0 && (
            <Button onClick={() => setDialogStage(1)} color='primary'>
              NEXT
            </Button>
          )}
          {dialogStage === 1 && (
            <Button onClick={handleMerge} color='primary'>
              MERGE
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ManageCompanies;

function MergeForm({
  fields,
  formValues,
  setFormValues,
  selectedCompany,
  mergeCompany,
}) {
  const [inputDisabled, setInputDisabled] = useState(
    fields.reduce((previousValue, currentValue) => {
      return {
        ...previousValue,
        [currentValue.key]: true,
      };
    }, {})
  );

  const handleCustomAttribute = (e) => {
    if (e.target.id)
      setInputDisabled({ ...inputDisabled, [e.target.name]: false });
    else setInputDisabled({ ...inputDisabled, [e.target.name]: true });
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  return (
    <div className='grid grid-cols-4 grid-rows-3 gap-5 mt-10'>
      {fields.map((item, index) => (
        <Fragment key={index}>
          <h1 className='font-semibold'>{item.label}</h1>
          <h1>
            <input
              type='radio'
              name={item.key}
              className='mr-1'
              value={selectedCompany[item.key] || ''}
              onChange={handleCustomAttribute}
            />
            {selectedCompany[item.key]}
          </h1>
          <h1>
            <input
              type='radio'
              name={item.key}
              className='mr-1'
              value={mergeCompany[item.key] || ''}
              onChange={handleCustomAttribute}
            />
            {mergeCompany[item.key]}
          </h1>
          <h1>
            <input
              id='name'
              type='radio'
              name={item.key}
              className='mr-1'
              onChange={handleCustomAttribute}
            />
            <input
              type='text'
              name={item.key}
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  [e.target.name]: e.target.value,
                })
              }
              className='outline-none border border-solid border-black'
              disabled={inputDisabled[item.key]}
            />
          </h1>
        </Fragment>
      ))}
    </div>
  );
}
